import React from 'react'
import HeroComp from '../components/HeroComp'
import HeroImage from "../assets/about.jpg"
import AboutComp from '../components/AboutComp'
import Aboutcomp2 from '../components/Aboutcomp2'

export default function About() {
  return (
    <>
      <HeroComp heading="About Me" paragraph="Heyy... I'm Hammad Khan. I'm Full Stack and MERN Stack Developer. If You looking for a Web Developer then You are at the right place" src={HeroImage}/>
      <AboutComp />
      <Aboutcomp2 />
    </>
  )
}
